import styled from 'styled-components';
import useAccountPermission from '../../../hooks/useAccountPermission';
import useEnvPermission from '../../../hooks/useEnvPermission';
import useSelectedEnv from '../../../hooks/useSelectedEnv';
import { ToolRendererArgs } from '../types';
import InternalLink from '../../InternalLink';
import { APP_NAVIGATION_SCHEMA } from '../constants';

const StyledInternalLink = styled(InternalLink)`
  text-decoration: none;
  font-size: 14px;

  &:hover {
    text-decoration: underline;
  }
`;

const AppNavigationToolRenderer = (toolArgs: ToolRendererArgs) => {
  const envid = useSelectedEnv();
  const hasAccountPermission = useAccountPermission();
  const hasEnvPermission = useEnvPermission();

  const page = JSON.parse(toolArgs?.page);
  const { name, ...urlParams } = page;

  const navigationItem = APP_NAVIGATION_SCHEMA.find(
    (item) => item.name === name,
  );

  if (!navigationItem) {
    return <div />;
  }

  const path = navigationItem.path;
  const isAccountScopeRoute = navigationItem.accountScopeRoute;
  const envPermission = navigationItem.envPermission;
  const accountPermission = navigationItem.accountPermission;

  const searchParams = new URLSearchParams();
  Object.keys(urlParams).forEach((param) =>
    searchParams.set(param, urlParams[param]),
  );

  const urlOperator = path.includes('?') ? '&' : '?';

  const hasEnvPerm = envPermission ? hasEnvPermission(envPermission) : true;
  const hasAccountPerm = accountPermission
    ? hasAccountPermission(accountPermission)
    : true;

  const enabled = hasEnvPerm && hasAccountPerm;

  const basePath = isAccountScopeRoute ? path : `${envid}${path}`;
  const pathWithParams = searchParams.toString()
    ? `${basePath}${urlOperator}${searchParams.toString()}`
    : basePath;

  return (
    <StyledInternalLink $disabled={!enabled} to={pathWithParams}>{`${name}${
      enabled ? '' : ' (no permission)'
    }`}</StyledInternalLink>
  );
};

export default AppNavigationToolRenderer;
